import 'core-js/stable';
import 'regenerator-runtime/runtime';

// import './wdyr';
import React, { Suspense } from 'react';
import Loader from 'react-loader';
import {createRoot} from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'react-day-picker/lib/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-select/dist/react-select.css';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { Provider } from 'react-redux';
import store from './configureStore';
import Routes from './Routes';
import './assets/style.css';
import ErrorBoundary from './ErrorBoundary';
import GlobalLoader, { GlobalFetchLoader, GlobalMutateLoader } from './GlobalLoader';
import history from './containers/Utils/history';
import PracticeProviderProvider from './providers/PracticeProviderProvider';
import { handleApiError } from './containers/Utils/apiErrorHandler';
import { ReactQueryDevtools } from 'react-query/devtools';

// TODO 1: Remove font awesome
// TODO 2: Remove moment

const MOUNT_NODE = document.getElementById('app');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      onError: (err) => {
        handleApiError(err);
      },
      cacheTime: 5000,
    },
    mutations: {
      onError: (error) => {
        handleApiError(error);
      },
    },
  },
});


const theme = createTheme({
  typography: {
    fontFamily: 'Lato',
    color: '#424242',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': ['Lato'],
        '@color': '#424242',
      },
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#0076FF',
      },
    },
    MuiIconButton: {
      colorPrimary: {
        backgroundColor: '#0076FF',
      },
    },
    // MuiStepIcon: {
    //   root: {
    //     color: '#0076FF',
    //     '&$completed': {
    //       color: '#0076FF',
    //     },
    //     '&$active': {
    //       color: '#0076FF',
    //     },
    //   },
    // },
  },
});

const root = createRoot(MOUNT_NODE);

root.render(
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
              <Suspense fallback={<Loader loaded={false} />}>
                <PracticeProviderProvider>
                  <Routes />
                </PracticeProviderProvider>
              </Suspense>
              <GlobalLoader />
              <GlobalFetchLoader />
              <GlobalMutateLoader />
              {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />}
              <ToastContainer position="top-right" autoClose={5000} hideProgressBar newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss={false} draggable={false} pauseOnHover />
            </ThemeProvider>
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    </QueryClientProvider>
  )
